var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { InputEventType } from "./InputManager.js";
const haveEvents = "ongamepadconnected" in window;
const controllers = {};
const previousStates = {};
function connecthandler(e) {
  addgamepad(e.gamepad);
}
const listeners = [];
function addGamepadListener(listener) {
  listeners.push(listener);
  return () => {
    const index = listeners.indexOf(listener);
    listeners.splice(index, 1);
  };
}
function addgamepad(gamepad) {
  controllers[gamepad.index] = gamepad;
  requestAnimationFrame(updateStatus);
}
function disconnecthandler(e) {
  removegamepad(e.gamepad);
}
function removegamepad(gamepad) {
  const d = document.getElementById(`controller${gamepad.index}`);
  d && document.body.removeChild(d);
  delete controllers[gamepad.index];
}
function updateStatus() {
  if (!haveEvents) {
    scangamepads();
  }
  Object.entries(controllers).forEach(([i, controller]) => {
    const prevState = previousStates[controller.index] || {
      buttons: Array(controller.buttons.length).fill(0),
      axes: Array(controller.axes.length).fill(0)
    };
    controller.buttons.forEach((button, i2) => {
      let val = 0;
      if (typeof button === "object") {
        button.pressed;
        val = button.value;
      } else {
        val = button;
      }
      const pressChange = val !== (prevState.buttons[i2] ?? 0);
      if (pressChange) {
        listeners.forEach((listener) => listener(controller.index, false, i2, val));
      }
      prevState.buttons[i2] = val;
    });
    controller.axes.forEach((axis, i2) => {
      const prevAxis = prevState.axes[i2];
      axis = Math.round(axis * 100) / 100;
      const axisChange = axis !== prevAxis;
      if (axisChange) {
        listeners.forEach((listener) => listener(controller.index, true, i2, axis));
      }
      prevState.axes[i2] = axis;
    });
    previousStates[controller.index] = prevState;
  });
  requestAnimationFrame(updateStatus);
}
function scangamepads() {
  const gamepads = navigator.getGamepads();
  for (const gamepad of gamepads) {
    if (gamepad) {
      if (gamepad.index in controllers) {
        controllers[gamepad.index] = gamepad;
      } else {
        addgamepad(gamepad);
      }
    }
  }
}
window.addEventListener("gamepadconnected", connecthandler);
window.addEventListener("gamepaddisconnected", disconnecthandler);
if (!haveEvents) {
  setInterval(scangamepads, 500);
}
const StandardGamepadRegions = [
  {
    id: {
      type: "button",
      index: [12, 13, 14, 15]
    },
    type: "tap",
    key: ["up", "down", "left", "right"]
  },
  {
    id: {
      type: "axis",
      index: [0, 1],
      deadzone: 0.25
    },
    type: "joystick",
    key: ["a", "d", "w", "s"],
    skew: {
      zone: [10, 30],
      keys: ["↖️", "↘️"]
    }
  },
  {
    id: {
      type: "button",
      index: 0
    },
    type: "tap",
    key: "space"
  },
  {
    id: {
      type: "button",
      index: 1
    },
    type: "tap",
    key: "q"
  }
];
class GamepadListener {
  constructor(inputManager) {
    __publicField(this, "registry", {});
    __publicField(this, "unsubscribe", null);
    __publicField(this, "intitialDelay", 600);
    __publicField(this, "multiDelay", 80);
    this.inputManager = inputManager;
  }
  init(gamepadRegions) {
    this.unsubscribe = addGamepadListener((padIndex, isAxis, index, value) => {
      if (isAxis) {
        gamepadRegions.forEach((region) => {
          if (region.id.type === "axis" && (typeof region.id.index === "number" && region.id.index === index || Array.isArray(region.id.index) && region.id.index.includes(index))) {
            const axisIndexIndex = Array.isArray(region.id.index) ? region.id.index.indexOf(index) : 0;
            if (region.skew && Array.isArray(region.id.index) && region.id.index.length === 2) {
              let angle = Math.atan2(
                Math.abs(controllers[padIndex].axes[region.id.index[0]]),
                Math.abs(controllers[padIndex].axes[region.id.index[1]])
              ) * (180 / Math.PI);
              let baseIndex = 1;
              let relativeAngle = angle;
              if (angle > 45) {
                baseIndex = 0;
                relativeAngle = 90 - angle;
              }
              let altIndex = baseIndex === 0 ? 1 : 0;
              let inactiveKeys = [...region.key, ...region.skew.keys];
              let activeKeys = [];
              let value2 = controllers[padIndex].axes[region.id.index[baseIndex]];
              let altValue = controllers[padIndex].axes[region.id.index[altIndex]];
              if (relativeAngle < region.skew.zone[1]) {
                let index2 = value2 < 0 ? baseIndex * 2 : baseIndex * 2 + 1;
                let key = region.key[index2];
                if (Math.abs(value2) > (region.id.deadzone ?? 0)) {
                  activeKeys.push(key);
                }
                if (relativeAngle > region.skew.zone[0]) {
                  if (Math.abs(altValue) > (region.id.deadzone ?? 0)) {
                    activeKeys.push(region.skew.keys[altValue < 0 ? 0 : 1]);
                  }
                }
              } else {
                if (Math.abs(value2) > (region.id.deadzone ?? 0)) {
                  activeKeys.push(region.key[value2 < 0 ? baseIndex * 2 : baseIndex * 2 + 1]);
                }
                if (Math.abs(altValue) > (region.id.deadzone ?? 0)) {
                  activeKeys.push(region.key[altValue < 0 ? altIndex * 2 : altIndex * 2 + 1]);
                }
              }
              inactiveKeys = inactiveKeys.filter((key) => !activeKeys.includes(key));
              activeKeys.forEach((key) => {
                this.handleKeySimulation(key, true, padIndex);
              });
              inactiveKeys.forEach((key) => {
                this.handleKeySimulation(key, false, padIndex);
              });
            } else {
              let pressed = Math.abs(value) > (region.id.deadzone ?? 0);
              let key = region.key[axisIndexIndex * 2 + (value > 0 ? 1 : 0)];
              let otherKey = region.key[axisIndexIndex * 2 + (value > 0 ? 0 : 1)];
              this.handleKeySimulation(key, pressed, padIndex);
              this.handleKeySimulation(otherKey, false, padIndex);
            }
          }
        });
      } else {
        gamepadRegions.forEach((region) => {
          if (region.id.type === "button" && (typeof region.id.index === "number" && region.id.index === index || Array.isArray(region.id.index) && region.id.index.includes(index))) {
            const buttonIndexIndex = Array.isArray(region.id.index) ? region.id.index.indexOf(index) : 0;
            const pressed = value > (region.id.deadzone ?? 0);
            if (Array.isArray(region.key)) {
              this.handleKeySimulation(region.key[buttonIndexIndex], pressed, padIndex);
            } else {
              this.handleKeySimulation(region.key, pressed, padIndex);
            }
          }
        });
      }
    });
  }
  destroy() {
    this.unsubscribe && this.unsubscribe();
    this.unsubscribe = null;
    for (const padIndex in this.registry) {
      const registry = this.registry[padIndex];
      for (const key in registry) {
        clearInterval(registry[key][2]);
      }
    }
  }
  handleKeySimulation(key, pressed, padIndex) {
    if (!this.registry[padIndex]) {
      this.registry[padIndex] = {};
    }
    const registry = this.registry[padIndex];
    if (!registry[key]) {
      registry[key] = [0, 0, 0];
    }
    if (!pressed) {
      if (registry[key][0]) {
        clearInterval(registry[key][2]);
        this.inputManager.dispatchEvent(key, pressed, InputEventType.GAMEPAD);
        registry[key] = [0, 0, 0];
      }
    } else {
      let triggerTime = +/* @__PURE__ */ new Date();
      if (registry[key][0] === 0) {
        clearInterval(registry[key][2]);
        registry[key] = [
          triggerTime,
          triggerTime,
          setInterval(() => {
            this.handleKeySimulation(key, true, padIndex);
          }, this.multiDelay / 4)
        ];
        this.inputManager.dispatchEvent(key, pressed, InputEventType.GAMEPAD);
      } else if (registry[key][0] + this.intitialDelay < triggerTime) {
        if (registry[key][1] + this.multiDelay < triggerTime) {
          registry[key][1] = triggerTime;
          this.inputManager.dispatchEvent(key, pressed, InputEventType.GAMEPAD, padIndex);
        }
      }
    }
  }
}
export {
  GamepadListener,
  StandardGamepadRegions
};
//# sourceMappingURL=GamepadListener.js.map
